export default __webpack_public_path__ + "static/media/CC_StandAlone.973c0220.svg";